/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník plánů přehrávání.
 * @enum {string}
 */
const ScheduleEnum = {
  /** Playlist bude přehrán dle pořadí stop. V každém opakování se přehraje jen vybraný počet stop. */
  DYNAMIC: 'DYNAMIC',
  /** Playlist bude přehrán dle náhodného pořadí stop. Pořadí se při opakování nemění. */
  RANDOM: 'RANDOM',
  /** Playlist bude přehrán dle pořadí stop. */
  STATIC: 'STATIC'
};

export default ScheduleEnum;
